import { Injectable } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import { Observable } from 'rxjs';
import {LicenseService} from "./license.service";
import {filter, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class LicenseGuard implements CanActivate {
  constructor(private licenseService: LicenseService, private router: Router) {
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.licenseService.licenseValidatedObs().pipe(filter(valid => valid !== undefined), tap( valid => {
      if (!valid) {
        this.router.navigate(['/licensenotfound']);
      }
    }));
  }
}
